export default function Advice({color,children}){

    return(
        <div className={"advice"+(color=="orange"?" advice-orange":color=="red"?" advice-red":color=="yellow"?" advice-yellow":color=="green"?" advice-green":"")}>
            <div className="noselect">{children}</div>
        </div>
    )
    
}